import { Dispatch } from 'react';

export interface CLASetting {
  code: string;
  claId: number;
  claSvc: string;
  cla_ext: string;
}

export enum CLA_SETTINGS_FLAG {
  PLB_5_YEARS = 'PLB_5_YEARS',
  PLB_10_YEARS = 'PLB_10_YEARS',
  LEAVE_HOURS_EQUAL_PERIODS = 'LEAVE_HOURS_EQUAL_PERIODS',
  PROC_EXTRA_HOURS_NOMINAL = 'PROC_EXTRA_HOURS_NOMINAL',
  PLB_VISIBILITY = 'PLB_VISIBILITY',
  LEAVE_WEEK_HOURS_MAX = 'LEAVE_WEEK_HOURS_MAX',
  AGE_HOURS_AS_LEAVE_OVER = 'AGE_HOURS_AS_LEAVE_OVER',
  COMP_LEAVE_FIRST = 'COMP_LEAVE_FIRST',
  COMP_LEAVE_EARMARKED = 'COMP_LEAVE_EARMARKED',
  LEAVE_MIN_NEGATIVE = 'LEAVE_MIN_NEGATIVE',
  LEAVE_4_PLUS_BEFORE_MIN = 'LEAVE_4_PLUS_BEFORE_MIN',
  HOURS_LEAVE_NUC_NEXT_YEAR = 'HOURS_LEAVE_NUC_NEXT_YEAR',
  HOURS_PLB_NUC_NEXT_YEAR = 'HOURS_PLB_NUC_NEXT_YEAR',
  BLOCK_FESTIVE_DAY_HOUR = 'BLOCK_FESTIVE_DAY_HOUR',
  COMP_LEAVE_EXACT_HOLIDAY = 'COMP_LEAVE_EXACT_HOLIDAY',
  JUS_URC = 'JUS_URC',
  EXTRA_HOURS_NOT_ROUNDED = 'EXTRA_HOURS_NOT_ROUNDED',
  FULL_MONTH_OF_LEAVE_WHEN_START_DURING_MONTH = 'FULL_MONTH_OF_LEAVE_WHEN_START_DURING_MONTH'
}

export type TabProps = {
  setCurrentSchema: Dispatch<any>;
  isEditable?: boolean;
};

export interface CLAItem {
  hoursWorkingPerDay: number;
  code: string;
  year: number;
  attendanceWeekdayAllowanceAmount: number;
  flags: CLA_SETTINGS_FLAG[];
  description: string;
  onCallBaseHours: number;
  onCallWeekdayAllowanceHours: number;
  onCallWeekdayAllowanceAmount: number;
  onCallHolidayAllowanceAmount: number;
  attendanceWeekdayAllowanceHours: number;
  onCallWeekendAllowanceHours: number;
  onCallHolidayAllowanceHours: number;
  plbName: string;
  attendanceWeekendAllowanceAmount: number;
  onCallWeekendAllowanceAmount: number;
  hoursPlbYear: number;
  hoursWorkingPerYear: number;
  claExternalCode: string;
  hoursHolidayPerYear: number;
  attendanceHolidayAllowanceHours: number;
  hoursHolidayYearMinimum: number;
  attendanceBaseHours: number;
  attendanceHolidayAllowanceAmount: number;
  periodHours: number;
  hoursWorkingPerWeek: number;
  attendanceWeekendAllowanceHours: number;
  claId: number;
  hoursJusFestDays: number;
  claYearId: number;
  leaveHoursBasedOnWork: number;
  leaveHoursBasedOnPayed: number;
  leaveHoursZeroHourContract: number;
  capReferenceNetHours: number;
  workHoursBasedWeekdays?: number;
}

export interface CLAItemFormValues
  extends Omit<CLAItem, 'flags' | 'workHoursBasedWeekdays'> {
  flags: CLA_SETTINGS_FLAG;
  plbValidity:
    | CLA_SETTINGS_FLAG.PLB_5_YEARS
    | CLA_SETTINGS_FLAG.PLB_10_YEARS
    | '';
  rowId: number;
  workHoursBasedWeekdays: boolean;
}

export type DCCType = {
  dccId: number;
  code: string;
  description: string;
};

export enum TabType {
  GENERAL = 'general',
  LEAVE = 'leaveSetting',
  EXTRA_HOURS = 'extraHours',
  CAP_PLAN = 'capPlan',
  DEVIATING = 'deviating'
}
